import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import RangeSliderBorderRadius from "../../../UI/RangeSliderBorderRadius";
import {
  AlignHorizontalJustifyStart,
  AlignHorizontalJustifyEnd,
  AlignVerticalJustifyStart,
  AlignVerticalJustifyEnd,
  AlignHorizontalSpaceBetween,
  AlignHorizontalSpaceAround,
 
  AlignHorizontalJustifyCenter,
  AlignHorizontalDistributeCenter,
  AlignVerticalJustifyCenter,
  AlignVerticalDistributeCenter,
  AlignVerticalSpaceBetween,
  Square,
  Squircle,
  Circle,
  Palette,
} from "lucide-react";
import {
  AlignVerticalSpaceAround,
  AlignVerticalJustifyStretch,
} from "lucide-react";
import RangeSliderDynamic from "../../../UI/RangeSliderDynamic";
import ColorPickerDynamic from "../../../UI/ColorPicker/ColorPickerDynamic";
import Toggle from "../../../UI/Toggle";
const BoxShadowUI =  ({ itemsArray, callbackItemValue, objectValue,objectName,displayName ,}) => {

     const dispatch = useDispatch();  
     const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
            {
              
              dispatch({type: "CURSOR",payload:true  });
          
              dispatch({type: "CURSORTEXT",payload:CursorText})
              dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
              dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
            }
             
            const handleMouseLeave = () => {
              
              dispatch({type: "CURSOR",payload:false})
          
              dispatch({type: "CURSORTEXT",payload:""})
          
              dispatch({type: "CURSORTEXTBG",payload:""})
              dispatch({type: "CURSORTEXTCOLOR",payload:""})
            
          
          }
 const [itemValue, setItemValue] = useState(objectValue);
 const [palletBoxShadowColor, setPalletBoxShadowColor] = useState(false);

 return(<div style={{margin:"5px",background:"rgb(208, 234, 255)",padding:"5px",borderRadius:"15px",}}>
 <div style={{background:"rgb(208, 234, 255)",position:"relative",borderRadius:"15px",padding:"0px",display:"flex",justifyContent:"space-between"}}>
                 
<h4>{objectValue?.title+" Color"} </h4>
<div> <label onMouseEnter={
                                                            ()=>handleMouseEnter("#fff","#333","")}
                                             onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}style={{background:objectValue?.shadowColor?.color}}>
                                                           <div style={{display:"flex",justifyContent:"space-between"}} >
                                                           
                                                            <Palette onMouseEnter={handleMouseEnter}
                                                                                    onMouseLeave={handleMouseLeave}  onClick={()=>{ }} style={{position:"relative"}}   color="#555" size={22}/>
                                                                                    
                                                            </div> 
                                             <input type="checkbox" title="Color Theme"   checked={palletBoxShadowColor?"yes":""}
                                  className="input-textbox"  value={palletBoxShadowColor}  name="palletBoxShadowColor1"  
                                  onChange={e=>{setPalletBoxShadowColor(e.target.checked);}}/>
                                       <span class={"boxCardBorder-two"}></span> </label>
{palletBoxShadowColor?<>
 <div style={{position:"absolute",right:"0px",bottom:"75px",zIndex:"9999999"}}><ColorPickerDynamic activeColorPickerValue={objectValue?.shadowColor} setActiveColorPickerValue={(color)=>{
callbackItemValue(color,objectName+"ShadowColor");}} colorPickerOptionArray={[]}   palletTitle={objectValue?.shadowColor?.title} /> 
</div></>:"" }</div>
</div>
                                      <div style={{position:"relative"}}>
                   <div style={{background:"#fff",borderRadius:"15px",padding:"0px",marginTop:"10px",padding:"5px",display:"flex",justifyContent:"space-around"}}>
                 <div style={{paddingTop:"0px",}}> <h4> Horizontal Shadow </h4></div> 
               <RangeSliderDynamic   rangeIntervalType="layoutPadding" rangeStart={1} rangeEnd={200} pxPerType={"px"}  
       setSliderVal={(value)=>{ callbackItemValue({value:value,resolution:"px"},objectName+"Horizontal")}}  sliderVal={objectValue?.horiznotal?.value} />
       </div>      <div style={{background:"#fff",borderRadius:"15px",padding:"0px",marginTop:"10px",padding:"5px",display:"flex",justifyContent:"space-around"}}>
                 <div style={{paddingTop:"0px",}}> <h4> Vertical Shadow </h4></div> 
               <RangeSliderDynamic   rangeIntervalType="layoutPadding" rangeStart={1} rangeEnd={200} pxPerType={"px"}  
       setSliderVal={(value)=>{  callbackItemValue({value:value,resolution:"px"},objectName+"Vertical")}}  sliderVal={objectValue?.vertical?.value} />
       </div>                        
 <div style={{background:"#fff",borderRadius:"15px",padding:"0px",marginTop:"10px",padding:"5px",display:"flex",justifyContent:"space-around"}}>
                 <div style={{paddingTop:"0px",}}> <h4> Blur Shadow </h4></div> 
               <RangeSliderDynamic   rangeIntervalType="layoutPadding" rangeStart={1} rangeEnd={200} pxPerType={"px"}  
       setSliderVal={(value)=>{  callbackItemValue({value:value,resolution:"px"},objectName+"Blur")}}  sliderVal={objectValue?.blur?.value} />
       </div>                        
 <div style={{background:"#fff",borderRadius:"15px",padding:"0px",marginTop:"10px",padding:"5px",display:"flex",justifyContent:"space-around"}}>
                 <div style={{paddingTop:"0px",}}> <h4> Spread Shadow </h4></div> 
               <RangeSliderDynamic   rangeIntervalType="layoutPadding" rangeStart={1} rangeEnd={200} pxPerType={"px"}  
       setSliderVal={(value)=>{  callbackItemValue({value:value,resolution:"px"},objectName+"Spread")}}  sliderVal={objectValue?.spread?.value} />
       </div>                        

   <div className="gridForFiftyFixed"style={{}}><div><h4>Set Inner Shadow </h4></div>
                                <Toggle state={objectValue?.inset} toggleState={(state)=>{
                                 callbackItemValue(state,objectName+"Inset")}} />
                                   </div> 

</div>
                                 </div>)

    } 
    export default BoxShadowUI;

                     

